import { SimNao } from "src/app/view/budget/model/orcamento-forma-pagamento.model";
import { BaseModel } from "./base-model";

export enum TipoEmpresa {
  FILIAL = "FILIAL",
  MATRIZ = "MATRIZ",
}

export class Empresa extends BaseModel {
  bairro: string;
  cep: string;
  cidade: string;
  cnaes: EmpresaCnaeRequest[];
  cnpj: string;
  codigoIbgeCidade: number;
  codigoIbgeUf: number;
  complemento: string;
  crt: string;
  email: string;
  id: number;
  idempresa: number;
  imagemLogotipo?: string;
  inscricaoEstadual?: string;
  inscricaoEstadualSt?: string;
  inscricaoMunicipal?: string;
  logradouro: string;
  nomeFantasia?: string;
  numero: string;
  razaoSocial: string;
  telefone?: string;
  tipo: TipoEmpresa;
  tipoRegime: string;
  uf: string;

  static fromJson(jsonData: any): Empresa {
    return Object.assign(new Empresa(), jsonData);
  }
}

export interface EmpresaCnaeRequest {
  codigo: string;
  principal: SimNao;
  ramoAtividade: string;
}
